import { isGpEumRequestType } from "./isGpEumRequestType";
import type { BillingCaseRowItem } from "../../types";

export type PendingChangeRequestIdsByType = {
  legacyPendingIds: string[];
  gpPendingIds: string[];
};

export const getPendingChangeRequestIdsByType = (
  requestType: BillingCaseRowItem["requestType"] | undefined,
  pendingChangeRequestIds: string[],
): PendingChangeRequestIdsByType =>
  isGpEumRequestType(requestType)
    ? { legacyPendingIds: [], gpPendingIds: pendingChangeRequestIds }
    : { legacyPendingIds: pendingChangeRequestIds, gpPendingIds: [] };
